// extracted by mini-css-extract-plugin
export var inlineLink = "_ab-0";
export var inlineLinkButton = "_ab-1";